import React from "react";
import { Avatar, Card, Progress } from "antd";
import { Trophy } from "lucide-react";

const activityDetail = [
  { name: "Alice Johnson", department: "Engineering", role: "Senior Developer", points: 1000 },
  { name: "Clara Lee", department: "Marketing", role: "Marketing Lead", points: 750 },
  { name: "David Smith", department: "Human Resources", role: "HR Manager", points: 650 },
  { name: "Emily Davis", department: "Finance", role: "Financial Analyst", points: 800 },
  { name: "Franklin Brown", department: "Engineering", role: "DevOps Engineer", points: 700 },
  { name: "Grace Wilson", department: "Product", role: "Product Manager", points: 0 },
  { name: "Hannah Martinez", department: "Design", role: "UI/UX Designer", points: 0 },
  { name: "Ian Thompson", department: "Sales", role: "Sales Executive", points: 0 },
  { name: "Julia Roberts", department: "Engineering", role: "Frontend Developer", points: 0 },
  { name: "Kevin Lee", department: "Support", role: "Customer Support", points: 0 },
];

const getRankStyles = (rank) => {
  switch (rank) {
    case 1:
      return {
        card: "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50/50 to-white py-1",
        avatar: "bg-gradient-to-br from-yellow-400 to-yellow-600 text-white",
        rank: "bg-gradient-to-br from-yellow-400 to-yellow-600 text-white",
      };
    case 2:
      return {
        card: "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50/50 to-white py-0.5",
        avatar: "bg-gradient-to-br from-gray-400 to-gray-600 text-white",
        rank: "bg-gradient-to-br from-gray-400 to-gray-600 text-white",
      };
    case 3:
      return {
        card: "border-2 border-yellow-300 bg-gradient-to-r from-yellow-50/50 to-white",
        avatar: "bg-gradient-to-br from-orange-400 to-orange-600 text-white",
        rank: "bg-gradient-to-br from-orange-400 to-orange-600 text-white",
      };
    default:
      return {
        card: "border border-slate-200 bg-card",
        avatar: "bg-gradient-to-br from-slate-200 to-slate-400",
        rank: "bg-gradient-to-br from-slate-200 to-slate-400",
      };
  }
};

const Leaderboards = () => {
  const sortedData = [...activityDetail].sort((a, b) => b.points - a.points);
  const highestPoints = sortedData[0]?.points || 1;

  return (
    <div className="flex flex-col gap-3">
      {sortedData.map((item, index) => {
        const rank = index + 1;
        const styles = getRankStyles(rank);

        const percentage = ((Number(item.points) || 0) / (Number(highestPoints) || 1)) * 100;

        return (
          <Card key={index} className={`rounded-xl ${styles.card}`}>
            <div className="flex justify-between items-center">
              <div className="flex justify-between items-center gap-3">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full font-semibold ${styles.rank}`}
                >
                  #{rank}
                </div>
                <Avatar
                  size={40}
                  className="bg-gradient-to-br from-emerald-500 to-violet-500 overflow-hidden"
                >
                  {item.name?.split(" ").map((n) => n[0]).join("")}
                </Avatar>
                <div className="flex-1">
                  <p className="inline-flex gap-2 font-medium text-[13px]">
                    {item.name} <Trophy className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                  </p>
                  <p className="text-[11px]">{item.role}</p>


                </div>
              </div>

              <div className="flex flex-col items-end">
                <span className="rounded-xl border px-2 py-0.5 text-[11px] font-semibold bg-gradient-to-r from-emerald-500 to-purple-500 text-white">
                  +{item.points} credits
                </span>
                <span className="text-[11px] text-muted-foreground dark:text-zinc-500 mt-1">
                  {item.department}
                </span>
              </div>
            </div>
            {percentage >= 0.1 && (
              <div className="mt-3">
                <Progress
                  percent={parseFloat(percentage.toFixed(1))}
                  showInfo={false}
                  strokeColor="#22c55e"
                  trailColor="rgba(34, 197, 94, 0.2)"
                  strokeWidth={8}
                  strokeLinecap="round"
                />
              </div>
            )}
          </Card>
        );
      })}
    </div>
  );
};

export default Leaderboards;
